module.exports = __webpack_public_path__ + "static/media/logo-2.b631c9e7.svg";